import { IcColorStatusSActive } from '@assets/icons/24x24';
import { For, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { formatDurationFromMillis } from '@utils/date.utils';
import { FormattedMessage } from 'react-intl';

export type OperatingModuleProps = {
  customLabelKey?: string;
  operatingValues: Map<string, { value: boolean | null | undefined; time?: number | null; color?: string }>; // Time in millisecond
};

export default function OperatingModule({ operatingValues, customLabelKey }: Readonly<OperatingModuleProps>) {
  const getValueLabel = (value: boolean | null | undefined) => {
    if (value == null) {
      return 'global.NA';
    } else {
      return `global.${value ? 'on' : 'off'}`;
    }
  };

  return (
    <VStack paddingX={9} paddingY={4} backgroundColor="neutral.700" gap={1} flex="1" height="100%" alignItems="start">
      <Text paddingY="11px" fontWeight="medium" color="neutral.200" textTransform="uppercase">
        <FormattedMessage id={customLabelKey ?? 'components.monitoring.sensorDetail.global.operating.title'} />
      </Text>
      <For
        each={Array.from(operatingValues.entries())}
        fallback={
          <Text color="neutral.300">
            <FormattedMessage id="components.monitoring.sensorDetail.global.empty" />
          </Text>
        }
      >
        {([name, values]) => (
          <HStack paddingY="7px" width="100%" gap={6} key={name} alignItems="start">
            <Text color="neutral.300" flexShrink={0}>
              <FormattedMessage id={`components.monitoring.sensorDetail.global.operating.${name}`} />
            </Text>
            <VStack marginLeft="auto" gap={0.5}>
              <HStack marginLeft="auto" gap={1} alignItems="end">
                <Text fontWeight="medium" textTransform="uppercase">
                  <FormattedMessage id={getValueLabel(values.value)} />
                </Text>
                {values.value !== null && values.value !== undefined && values.color && (
                  <Icon boxSize="16px" color={values.color} as={IcColorStatusSActive} />
                )}
              </HStack>
              {values.time != null && values.value != null && (
                <Text marginLeft="auto" color="neutral.200">
                  <FormattedMessage
                    id="global.since"
                    values={{
                      duration: formatDurationFromMillis(values.time, ['days', 'hours', 'minutes']),
                    }}
                  />
                </Text>
              )}
            </VStack>
          </HStack>
        )}
      </For>
    </VStack>
  );
}
